<template>
  <div id="nest">
    <div class="nest_tit">꿈 둥지(구직자 전용 카페)</div>
    <div class="nest_cont">
      <div class="nest_cont_item">
        <div class="cont_tit">이용방법</div>
        <div class="cont_desc">구로구 중장년 일드림센터 구직등록한 분</div>
      </div>
      <div class="nest_cont_item">
        <div class="cont_tit">이용시간</div>
        <div class="cont_desc">평일 10:00~17:00</div>
      </div>
      <div class="nest_cont_item">
        <div class="cont_tit">카페쿠폰</div>
        <div class="cont_desc">
          꿈 둥지는 구직등록, 상담, 강의 수료.<br>
          * 만35세이상 구직자(구로구민 우대)
        </div>
      </div>
      <div class="nest_cont_item">
        <div class="cont_tit">구비사항</div>
        <div class="cont_desc">채용정보 검색용 PC3대,  커피 & 음료, 서울시 기증 도서 100권</div>
      </div>
    </div>
    <div class="nest_list">
      <div class="nest_item">
        <div class="tit">음식물 반입 No!</div>
        <div class="desc">
          준비된 음료외 음식물은<br>
          반입을 삼가해주세요
        </div>
        <img src="../../assets/nest/ic_nest_01.svg"/>
      </div>
      <div class="nest_item">
        <div class="tit">도서는 제자리에</div>
        <div class="desc">
          서울시 기증도서이니,<br>
          깨끗하게 보고 제자리에 놓아주세요
        </div>
        <img src="../../assets/nest/ic_nest_02.svg"/>
      </div>
      <div class="nest_item">
        <div class="tit">정보탐색을 하는 곳</div>
        <div class="desc">
          구직활동을 위한 정보공유<br>
          장소로 이용해주세요
        </div>
        <img src="../../assets/nest/ic_nest_03.svg"/>
      </div>
      <div class="nest_item">
        <div class="tit">퇴실전 정리정돈</div>
        <div class="desc" v-if="isMobile">퇴실 시에는 다음 이용자를 위해 사용한 좌석은 정리해주세요</div>
        <div class="desc" v-else>
          퇴실 시에는 다음 이용자를 위해<br>
          사용한 좌석은 정리해주세요
        </div>
        <img src="../../assets/nest/ic_nest_04.svg"/>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'

export default {
  data () {
    return {
      isMobile: common.detectMobile()
    }
  }
}
</script>

<style scoped>
.mobile_wrap #nest {
  padding: 0 16px;
  box-sizing: border-box;
}

.nest_tit {
  margin-top: 55px;
  color: #0F1015;
  font-size: 38px;
  font-weight: 400;
  text-align: left;
}

.mobile_wrap .nest_tit {
  margin-top: 40px;
  font-size: 18px;
}

.nest_cont {
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  gap: 30px;
}

.mobile_wrap .nest_cont {
  margin-top: 40px;
  gap: 15px;
}

.nest_cont > .nest_cont_item {
  display: flex;
}

.nest_cont > .nest_cont_item > div {
  color: #1F1F1F;
  font-weight: 400;
  letter-spacing: 0.7px;
  text-align: left;
}

.nest_cont > .nest_cont_item > .cont_tit {
  width: 100px;
  font-size: 20px;
  line-height: 27px; /* 135% */
}

.mobile_wrap .nest_cont > .nest_cont_item > .cont_tit {
  flex-shrink: 0;
  width: 80px;
  font-size: 16px;
  line-height: 1.5;
}

.nest_cont > .nest_cont_item > .cont_desc {
  font-size: 16px;
  line-height: 27px; /* 168.75% */
}

.mobile_wrap .nest_cont > .nest_cont_item > .cont_desc {
  font-size: 14px;
  line-height: 1.5;
}

.nest_list {
  display: flex;
  width: 100%;
  margin: 80px 0 180px;
  gap: 30px;
}

.mobile_wrap .nest_list {
  flex-wrap: wrap;
  margin: 40px 0 100px;
  gap: 15px;
}

.nest_list > .nest_item {
  display: flex;
  flex-direction: column;
  width: 25%;
  height: 250px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.05);
}

.mobile_wrap .nest_list > .nest_item {
  height: auto;
  padding-bottom: 20px;
}

.mobile_wrap .nest_list > .nest_item {
  width: calc(50% - 7.5px);
}

.nest_list > .nest_item > img {
  margin: 0 auto auto;
}

.mobile_wrap .nest_list > .nest_item > img {
  margin: 20px auto 0;
}

.nest_list > .nest_item > .tit {
  margin: 18px auto 0;
  color: #14171D;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
}

.mobile_wrap .nest_list > .nest_item > .tit {
  margin-top: 10px;
  font-size: 16px;
}

.nest_list > .nest_item > .desc {
  margin: 25px auto auto;
  color: #606267;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.mobile_wrap .nest_list > .nest_item > .desc {
  margin-top: 16px;
  font-size: 14px;
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/components/participation/Nest.vue